<template>
  <div>
    <Textbox @input="load" placeholder="Search triggers." />

    <div v-if="itemsLoading" class="flex justify-center py-6">
      <Spinner class="w-10 h-10 text-gray-400" />
    </div>

    <ul class="divide-y divide-gray-200 mt-3" v-else>
      <ListItem
        v-for="item in items"
        :item="item"
        :key="item._id"
        :selected="item._id === selectedId"
        :loading="item._id === selectedId && itemLoading"
        @select="handleSelect(item)"
      />
    </ul>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { defineComponent } from "vue";
import Textbox from "@/components/common/fields/Textbox";
import Spinner from "@/components/common/Spinner";
import ListItem from "./ListItem";

export default defineComponent({
  emits: ["change"],

  components: {
    Textbox,
    Spinner,
    ListItem,
  },

  props: {
    selected: String,
  },

  data() {
    return {
      items: [],
      selectedId: null,
      itemLoading: false,
      itemsLoading: true,
    };
  },

  methods: {
    load: debounce(async function (event) {
      this.itemsLoading = true;

      try {
        const { data: items } = await this.$axios.get("/triggers", {
          params: {
            "filters[name]": event?.target.value ?? "",
          },
        });

        this.items = items.data;
      } catch (error) {
        console.log(error);
      }

      this.itemsLoading = false;
    }, 300),

    async handleSelect(item) {
      this.selectedId = item._id;
      this.itemLoading = true;

      try {
        const { data: item } = await this.$axios.get(
          `/triggers/${this.selectedId}`
        );

        this.$emit("change", item.data);
      } catch (error) {
        this.selectedId = null;
      }

      this.itemLoading = false;
    },
  },

  created() {
    this.load();
    this.selectedId = this.selected;
  },

  watch: {
    selected(value) {
      this.selectedId = value;
    },
  },
});
</script>
